import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarOff = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L7.55536 8.61602L3.38606 9.25695C3.10829 9.29965 2.8777 9.49406 2.78866 9.76061C2.69962 10.0272 2.76706 10.3211 2.9634 10.5222L6.94884 14.604L6.0068 20.3793C5.96056 20.6627 6.08028 20.9477 6.3151 21.1131C6.54992 21.2786 6.85858 21.2953 7.10994 21.1563L12 18.4524L16.8901 21.1563C17.1415 21.2953 17.4501 21.2786 17.6849 21.1131C17.9198 20.9477 18.0395 20.6627 17.9932 20.3793L17.7349 18.7956L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L3.53033 2.46967ZM15.9189 16.9795L8.87076 9.93143L5.05565 10.5179L8.28664 13.827C8.45301 13.9974 8.52857 14.2366 8.49024 14.4717L7.73591 19.0962L11.6371 16.9391C11.8629 16.8142 12.1371 16.8142 12.3629 16.9391L16.2641 19.0962L15.9189 16.9795Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.9444 10.5179L16.8175 12.6962L17.8782 13.7569L21.0366 10.5222C21.233 10.3211 21.3004 10.0272 21.2114 9.7606C21.1223 9.49405 20.8917 9.29964 20.614 9.25695L15.1352 8.41484L12.679 3.18136C12.5554 2.91812 12.2909 2.75002 12.0001 2.75C11.7093 2.74998 11.4447 2.91805 11.3211 3.18127L10.0372 5.91592L11.1649 7.04359L11.9999 5.26504L13.9471 9.41404C14.0533 9.64025 14.2651 9.79873 14.5121 9.83669L18.9444 10.5179Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgStarOff);
export default ForwardRef;
